import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PageHeader from './components/PageHeader'
import DeviceModal from './components/DeviceModal'
import PageBody from './components/PageBody'
import Spinner from 'components/CommonUI/Spinner/Spinner'
import { useShallowEqualSelector } from 'custom-hooks'

import {
  loadingDevices,
  getDevicesListSelector,
  getIsfetchingDevicesSelector,
} from 'redux/reducers/devices'

export const modalTypesConstant = {
  create: 'create',
  edit: 'edit',
}

const DevicesManagement = () => {
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [modalType, setModalType] = useState(modalTypesConstant.create)
  const [editingData, setEditingData] = useState(null)
  const [searchValue, setSearchValue] = useState('')

  const devicesList = useShallowEqualSelector(getDevicesListSelector)
  const isFetching = useShallowEqualSelector(getIsfetchingDevicesSelector)

  const dispatch = useDispatch()

  const handleToggleModal = useCallback(
    (type) => (editingData) => {
      setIsOpenModal((pr) => !pr)
      setModalType(type)
      setEditingData(editingData)
    },
    []
  )

  const handleCloseModal = useCallback(() => {
    setIsOpenModal(false)
  }, [])

  useEffect(() => {
    dispatch(loadingDevices())
  }, [dispatch])

  const searchFilteringData = devicesList.filter((d) =>
    String(d.name)
      .toLocaleLowerCase()
      .includes(String(searchValue).toLocaleLowerCase())
  )

  return (
    <div className="devices_manage_page_container">
      {isFetching && <Spinner />}
      <PageHeader
        handleCreate={handleToggleModal}
        searchValue={searchValue}
        handleSearchChange={setSearchValue}
      />
      <PageBody
        handleEdit={handleToggleModal}
        devicesList={searchFilteringData}
        isFetching={isFetching}
      />
      {isOpenModal && (
        <DeviceModal
          handleClose={handleCloseModal}
          type={modalType}
          editingData={editingData}
        />
      )}
    </div>
  )
}

export default DevicesManagement
